<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <v-card>
      <v-card-title class="d-flex align-center justify-center py-7">
        <router-link
            to="/"
            class="d-flex align-center"
        >
          <v-img
              :src="require('@/assets/sp/logo.svg')"
              alt="logo"
              width="100"
              class="me-2"
          ></v-img>
        </router-link>
      </v-card-title>
      <v-divider/>
      <v-card-title class="text-h6 text-capitalize">
        {{ params.title }}
      </v-card-title>
      <v-divider/>
      <v-card-text>
        {{params.text}}
      </v-card-text>
      <v-divider/>
      <v-card-text>
        <v-otp-input
            v-model="input"
            :length="params.length"
            @finish="confirm"
        ></v-otp-input>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import {EventBus} from "../../../shared/utilities/event-bus";

export default {
  name: "OTP",
  data: function () {
    return {
      dialog: false,
      params: {
        title: "",
        text: "",
        input: false,
        label: "",
        length:6,
        rejectLabel: "",
        acceptLabel: "",
        onConfirm: {},
        onCancel: {},
      },
      input: "",
      hasErrors: false,
    };
  },

  mounted() {
    EventBus.$on("openOTP", (params) => {
      this.show(params);
    });
  },

  methods: {
    show: function (params) {
      this.params = params;
      this.dialog = true;
    },

    hide: function () {
      this.dialog = false;
    },

    confirm: function () {
      if (typeof this.params.onConfirm === "function") {
        if (this.params.input === true && this.input === "") {
          this.hasErrors = true;
        } else {
          this.hasErrors = false;
          this.params.onConfirm(this.input);
          this.input = "";
          this.hide();
        }
      } else {
        this.hide();
        this.input = "";
      }
    },

    cancel: function () {
      if (typeof this.params.onCancel === "function") {
        this.params.onCancel();
        this.hide();
        this.input = "";
      } else {
        this.hide();
        this.input = "";
      }
    },
  },
};
</script>

<style scoped></style>
